import { UseFormReturn } from 'react-hook-form'

import { TransactionOverview } from '../components/TransactionOverview'
import { TxOverview } from '../logic/createTxOverview'
import { TokenWithBalance } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { Alert } from '@/ui/molecules/alert/Alert'

export interface StakeViewProps {
  selectableAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  sacrificesYield: boolean
  form: UseFormReturn<AssetInputSchema>
  txOverview: TxOverview
  actionsViewState: ActionsViewState
}

export function StakeView({
  selectableAssets,
  assetsFields,
  sacrificesYield,
  form,
  txOverview,
  actionsViewState,
}: StakeViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Deposit into SPK Farm</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
        <TransactionOverview txOverview={txOverview} selectedToken={assetsFields.selectedAsset} />
      </FormAndOverviewWrapper>

      {sacrificesYield && (
        <Alert variant="error">
          <p className="max-w-[60ch]">
            Depositing your savings token means that you will no longer earn yield directly from it. Instead, you will
            receive yield from the specific farm you deposit it into.
          </p>
        </Alert>
      )}

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
